import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IpCheckPage } from '@zg-rentals/particles-js-ip-check';
import UserActions from '../../../flux/actions/UserActions';

class IpCheckPageWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      browserIpFromApi: {},
      browserIpFromApiNoProxy: {},
    };
  }
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(UserActions.getIp())
      .then((response) => {
        if (typeof response === 'object') {
          this.setState({
            browserIpFromApi: response,
          });
        }
        return;
      })
      .catch(() => {});

    dispatch(UserActions.getIp(true))
      .then((response) => {
        if (typeof response === 'object') {
          this.setState({
            browserIpFromApiNoProxy: response,
          });
        }
        return;
      })
      .catch(() => {});
  }

  render() {
    const { browserIpFromApi, browserIpFromApiNoProxy } = this.state;
    const { fullReqIps, ip, ipFromApi } = this.props;

    return (
      <IpCheckPage
        nodeDetectedIp={ip}
        serverIpsFromNode={fullReqIps}
        serverIpsFromApi={ipFromApi}
        browserIpsFromApi={browserIpFromApi}
        browserIpsFromApiNoProxy={browserIpFromApiNoProxy}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  ip: state.user.ip,
  ipFromApi: state.user.ipFromJava,
  fullReqIps: state.user.fullReqIps,
});

IpCheckPageWrapper.propTypes = {
  ip: PropTypes.string,
  ipFromApi: PropTypes.shape({
    clientIpHeaders: PropTypes.arrayOf(PropTypes.string),
    forwardedForHeaders: PropTypes.arrayOf(PropTypes.string),
    remoteAddr: PropTypes.string,
    detectedIp: PropTypes.string,
  }),
  fullReqIps: PropTypes.shape({
    zgIpHeader: PropTypes.string,
    xForwadedFor: PropTypes.string,
    connectionRemoteAddress: PropTypes.string,
    socketRemoteAddres: PropTypes.string,
    connectionSocketRemoteAddress: PropTypes.string,
  }),
  dispatch: PropTypes.func,
};

export default connect(mapStateToProps)(IpCheckPageWrapper);
